import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withFetch,
} from "@angular/common/http";
import { provideClientHydration } from "@angular/platform-browser";
import {
  provideAnimations,
  provideNoopAnimations,
} from "@angular/platform-browser/animations";
import { httpErrorInterceptor } from "./shared/interceptors/http-error/http-error.interceptor";
import { MessageService } from "primeng/api";
import { AuthService } from "./shared/services/auth/auth.service";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// Loader tłumaczeń kreatora – pliki JSON w assets/i18n (pl.json, en.json).
export function translateHttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export const appConfig: ApplicationConfig = {
  providers: [
    AuthService,
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch()),
    provideAnimations(),
    provideNoopAnimations(),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(
      withInterceptors([
        httpErrorInterceptor,
      ]),
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "pl",
        loader: {
          provide: TranslateLoader,
          useFactory: translateHttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    {
      provide: LOCALE_ID,
      useValue: "pl-PL",
    },
  ],
};
